<template>
  <div
    class="check-setting"
    :style="{
      'margin-bottom': (data.marginBottom ) / 16 + 'rem',
    }"
  >
    <img
      :style="{
        width: (data.imgWidth ) / 16 + 'rem',
        height: (data.imgHeight ) / 16 + 'rem',
        'margin-left': (data.imgMarginLeft ) / 16 + 'rem',
        'margin-right': (data.imgMarginRight ) / 16 + 'rem',
      }"
      :src="imgUrl"
      @click="changeProtocol"
    >
    <div>
      <span
        :style="{
          fontSize: (data.fontSize ) / 16 + 'rem',
          fontWeight: data.fontWeight,
          color: data.titleColor,
        }"
      >{{ data.title }}</span>
      <span
        v-for="(item, index) in data.lists"
        :key="index"
        @click="clickProtocol(item)"
      >
        <span 
          :style="{
            fontSize: (data.proFontSize ) / 16 + 'rem',
            color: data.proColor,
          }"
        >{{ item.title }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckProtocol",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      imgUrl: this.data.imaged,
    };
  },
  watch: {
    "data.checked"(val) {
      this.imgUrl = val ? this.data.imaged : this.data.image;
    },
  },
  // 把默认是否勾选协议的状态存到缓存中
  created() {
    localStorage.setItem('protoState', this.data.checked)
  },
  methods: {
    changeProtocol() {
      this.data.checked = !this.data.checked;
      // 更新缓存中勾选协议的状态
      localStorage.setItem('protoState', this.data.checked)
    },
    clickProtocol(item) {
      window.location.href = item.link;
    },
  },
};
</script>

<style lang="less" scoped>
.check-setting {
  display: flex;
  overflow: hidden;
  border-radius: 5px;
  padding: 0 10px;
  word-break: break-all;
  white-space: pre-line;
  align-items: center;
}
</style>
